import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

const BaseTransition = props => {
  const {
    baseClassName = '',
    baseStyles,
    children,
    duration,
    in: inProp,
    timeout,
    transitionStyles,
    unmount,
    ...rest
  } = props;
  return (
    <Transition in={inProp} timeout={{ enter: timeout, exit: duration }} {...rest}>
      {status => {
        if (unmount && status === 'exited') {
          return null;
        }
        return React.cloneElement(children, {
          ...children.props,
          className: `${children.props.className} ${baseClassName}`,
          style: {
            ...baseStyles,
            ...(transitionStyles[status] || {})
          }
        });
      }}
    </Transition>
  );
};

BaseTransition.propTypes = {
  baseClassName: PropTypes.string,
  baseStyles: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  children: PropTypes.node.isRequired,
  duration: PropTypes.number,
  in: PropTypes.bool,
  timeout: PropTypes.number,
  transitionStyles: PropTypes.shape({
    entering: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    entered: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    exiting: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    exited: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))
  }),
  unmount: PropTypes.bool
};

BaseTransition.defaultProps = {
  duration: 0,
  in: false,
  timeout: 0,
  transitionStyles: {},
  unmount: true
};

export default BaseTransition;
